import React from 'react'
import { Breadcrumb as BoltBreadcrumb } from '@sainsburys-tech/bolt'
import BackToSearch from '../BackToSearch/BackToSearch'

import * as Styled from './Breadcrumb.styles'

const BreadcrumbsBox = ({ children }) => (
  <Styled.Wrapper className='xs-12--none' data-test='breadcrumb-wrapper'>
    {children}
  </Styled.Wrapper>
)

const getAncestorInfo = categories => {
  const list = categories.map(category => {
    const { id, name, url: path } = category
    return { id, name, path }
  })
  return list
}

const Breadcrumb = props => {
  const {
    currentCategoryName: currentPageName,
    ancestors: ancestorList,
    onClickEvent: onClick,
    showOnlyLargeBreadcrumb
  } = props
  const showHomeLink = !ancestorList || !ancestorList[ancestorList.length - 1]
  const ancestors = getAncestorInfo(ancestorList)
  const metaData = true
  const options = {
    currentPageName,
    ancestors,
    onClick,
    showHomeLink,
    metaData,
    showOnlyLargeBreadcrumb
  }

  return (
    <BreadcrumbsBox>
      <BackToSearch />
      <BoltBreadcrumb {...options} />
    </BreadcrumbsBox>
  )
}

export default Breadcrumb
